const AlertType = Symbol();

export class Alert {

    [AlertType]: any;
    readonly category: string;
    readonly message: string;
    readonly date: string;
    readonly id: string;
    readonly display: boolean;
    readonly createdFrom: string;

    constructor(
        category: string,
        message: string,
        date: string,
        id: string,
        display: boolean,
        createdFrom: string,
    ) {
        this.category = category;
        this.message = message;
        this.date = date;
        this.id = id;
        this.display = display;
        this.createdFrom = createdFrom;
    }

    getCreaterLabel = () => {
        switch(this.createdFrom) {
            case "AI":
                return "AI";
            default:
                return "ルール";
        }
    };
}
